import { interact } from "fire-wind-water";
export default {
  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  },
  changeType(t) {
    let result = "";
    switch (Number(t)) {
      case 1:
        result = 3;
        break;
      case 2:
        result = 5;
        break;
      case 3:
        result = 2;
        break;
      case 4:
        result = 1;
        break;
      case 5:
        result = 4;
        break;
      case 6:
        result = 6;
        break;
      case 7:
        result = 8;
        break;
      case 8:
        result = 7;
        break;
      case 11:
        result = 9;
        break;
    }
    return result;
  },
  changeHash(info) {
    const arr = location.hash.split("?");
    if (info.type == 1 || info.type == 2) {
      if (location.hash.indexOf("questionnaire/") == -1) {
        window.location.hash = `#/questionnaire/${
          interact.isMobile == 1 ? "wap" : "pc"
        }/index${arr[1] ? "?" + arr[1] : ""}`;
      }
    } else if (info.type == 3 && info.questionBankId > 0) {
      if (location.hash.indexOf("examRandom/") == -1) {
        window.location.hash = `#/examRandom/${
          interact.isMobile == 1 ? "wap" : "pc"
        }/index${arr[1] ? "?" + arr[1] : ""}`;
      }
    } else {
      console.log(location.hash.indexOf("exam/"));
      if (location.hash.indexOf("exam/") == -1) {
        window.location.hash = `#/exam/${
          interact.isMobile == 1 ? "wap" : "pc"
        }/index${arr[1] ? "?" + arr[1] : ""}`;
      }
    }
  },

  //限时答题生成随机串
  limitTimeToken() {
    var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
    uuid = uuid.replace(/-/g, "");
    return uuid;
  },
};
